import i18n from 'constants/strings'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useFormLabels = () => {
  const { t } = useTranslation('strCommonUI')

  return useMemo(
    () => ({
      givenName: t('form.firstName'),
      familyName: t('form.lastName'),
      dateOfBirth: t('form.dob'),
      sex: t('form.sex'),
      nationality: t('form.nationality'),
      countryOfResidence: t('form.residence'),
      email: t('form.email'),
      male: t('form.sexMale'),
      female: t('form.sexFemale'),
      watchlistName: t('form.watchlistName'),
      parentGuardianName: t('form.parentGuardianName'),
      parentGuardianEmail: t('form.parentGuardianEmail'),
      personaSelect: t('form.personaSelect'),
      whereDidYouHearAboutUsSelect: t('form.whereDidYouHearAboutUsSelect'),
    }),
    [t]
  )
}

export const PLACEHOLDERS = {
  SEARCH_FIELD: {
    NATIONALITY: i18n.t('strCommonUI.placeholder.searchNationality'),
    COUNTRY_OF_RESIDENCE: i18n.t('strCommonUI.placeholder.searchResidence'),
    NA: i18n.t('strCommonUI.placeholder.searchNA'),
  },
}
